import {numeric, required} from "@vuelidate/validators";

const REPORT_VALIDATION = {
    SPRINKLING: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            },
            machine_id: {
                required
            },
            sprinkling_place_type: {
                required
            },
            layer_type: {
                required
            },
            emulsion_name: {
                required
            },
            emulsion_dosage: {
                required,
                numeric
            },
            surface_range: {
                required,
                numeric
            },
            sprinkling_place_start_km: {
                numeric
            },
            sprinkling_place_start_m: {
                numeric
            },
            sprinkling_place_end_km: {
                numeric
            },
            sprinkling_place_end_m: {
                numeric
            }
        }
    },
    WITHOUT_SPRINKLING: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            },
            machine_id: {
                required
            },
            emulsion_dosage: {
                numeric
            },
            surface_range: {
                numeric
            },
            activities_description: {
                required
            },
            sprinkling_place_start_km: {
                numeric
            },
            sprinkling_place_start_m: {
                numeric
            },
            sprinkling_place_end_km: {
                numeric
            },
            sprinkling_place_end_m: {
                numeric
            },
        }
    },
    DOWNTIME: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            },
            machine_id: {
                required
            },
            emulsion_dosage: {
                numeric
            },
            surface_range: {
                numeric
            },
            sprinkling_place_start_km: {
                numeric
            },
            sprinkling_place_start_m: {
                numeric
            },
            sprinkling_place_end_km: {
                numeric
            },
            sprinkling_place_end_m: {
                numeric
            }
        },
    },
    LEAVE: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            },
        }
    },
    SERVICE: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            },
            machine_id: {
                required
            },
            activities_description: {
                required
            }
        }
    },
    OTHERS: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            }
        }
    },
    SPRINKLER_MOBILIZATION: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            },
            machine_id: {
                required
            },
            sprinkling_place_type: {
                required
            },
            surface_range: {
                required,
                numeric
            },
            sprinkling_place_start_km: {
                numeric
            },
            sprinkling_place_start_m: {
                numeric
            },
            sprinkling_place_end_km: {
                numeric
            },
            sprinkling_place_end_m: {
                numeric
            }
        }
    },
    SPRINKLING_CURBS: {
        report: {
            work_type: {
                required
            },
            date: {
                required
            },
            investment_id: {
                required
            },
            machine_id: {
                required
            },
            sprinkling_place_type: {
                required
            },
            emulsion_name: {
                required
            },
            surface_range: {
                required,
                numeric
            },
            sprinkling_place_start_km: {
                numeric
            },
            sprinkling_place_start_m: {
                numeric
            },
            sprinkling_place_end_km: {
                numeric
            },
            sprinkling_place_end_m: {
                numeric
            }
        }
    }
};

const REPORT_VALIDATION_TYPES = {
    SPRINKLING: { validation: REPORT_VALIDATION.SPRINKLING },
    WITHOUT_SPRINKLING: { validation: REPORT_VALIDATION.WITHOUT_SPRINKLING },
    LEAVE: { validation: REPORT_VALIDATION.LEAVE },
    DOWNTIME: { validation: REPORT_VALIDATION.DOWNTIME },
    SERVICE: { validation: REPORT_VALIDATION.SERVICE },
    OTHERS: { validation: REPORT_VALIDATION.OTHERS },
    SPRINKLER_MOBILIZATION: { validation: REPORT_VALIDATION.SPRINKLER_MOBILIZATION },
    SPRINKLING_CURBS: { validation: REPORT_VALIDATION.SPRINKLING_CURBS }
};

export { REPORT_VALIDATION, REPORT_VALIDATION_TYPES }
